function r(n) {
  return n.replace(/\/+$/, "");
}
export {
  r as u
};
//# sourceMappingURL=untrailingSlashIt-BWo-cVq4.mjs.map
